import React, { useState, useEffect } from "react";
import { filterButton } from "../data/filterButton";
import { Button } from "../components/Button";
import { db } from "../config/firebase";
import { getDocs, collection } from "firebase/firestore";
import { Loading } from "../components/Loading";
import { Search } from "../components/Search";
import { SwiperComp } from "../components/SwiperComp";

export const Books = () => {
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const booksCollectionRef = collection(db, "Books");

  useEffect(() => {
    const getBooks = async () => {
      try {
        const data = await getDocs(booksCollectionRef);
        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setBooks(filteredData);
      } catch (error) {
        console.log("error____ ", error);
      }
    };
    getBooks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handelFilterBooks = (filterKey) => {
    setFilteredBooks(books.filter((book) => book.category === filterKey));
  };

  return (
    <div className="flex flex-col p-5 sm:px-10 md:p-10">
      <div className="px-5 md:hidden sm:px-0">
        <Search />
      </div>
      <h2 className="text-4xl font-semibold text-center text-gray-950 py-5 mb-5 sm:text-left">
        Choose your book
      </h2>

      <div className="mt-6 flex  flex-wrap xl:max-w-[80%]">
        {filterButton?.map((item) => (
          <Button item={item} key={item.id} handelClick={handelFilterBooks} />
        ))}
      </div>

      {!books.length ? (
        <Loading />
      ) : filteredBooks.length ? (
        <SwiperComp books={filteredBooks} />
      ) : (
        <SwiperComp books={books} />
      )}
    </div>
  );
};
